module.exports = __webpack_public_path__ + "img/hishi-mochi.dcdda7d.png";